import _slicedToArray from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";

function hashToObject(hash) {
  return hash.split('&').reduce(function (acc, keyValue) {
    var _keyValue$split = keyValue.split('='),
        _keyValue$split2 = _slicedToArray(_keyValue$split, 2),
        key = _keyValue$split2[0],
        value = _keyValue$split2[1];

    if (key) {
      acc[key] = value;
    }

    return acc;
  }, {});
}

export default hashToObject;